const initialState = () => ({
  forms: [],
  pendingTests: [],
  formsForApproval: [],
  blocks: [],
  critical: [],
  criticalItems: [],
  pagination: {},
  approvalPagination: {},
  status: null,
  message: null,
  groups: [],
  items: [],
  groupId: null,
  // Testing state
  currentTestOccurrence: null,
  testAnswers: {},
  testAddons: {}
})

export default initialState
